import { dementiaCareForm, mentalHealthForm } from '@/app/services';
import axios, { AxiosResponse } from 'axios';
import { AssessmentType, TRequest } from '../AssessmentPrinting/AssessmentPrintingList';
// import { TEditRequest } from './AssessmentFormMedicineService';

/**
 * 綜合評估服務 - 編輯評估單
 * @param {number} id - 評估單id
 * @param {{ fileUrl: string }} request - 請求物件
 * @prop {string} request.fileUrl - 檢查結果圖片網址
 * @returns {Promise<AxiosResponse<{ id: number }, TEditRequest>>} - 回應物件
 */
async function apiGetAssessmentForm(id: number) {
    const response: AxiosResponse<TEditRequest> = await axios.request({
        url: '/api/assessment-form/' + id.toString(),
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    });
    return response;
}

/**
 * @description API 請求參數
 * @property {number} userId - 會員id
 * @property {number} formId - 評估單id
 * @property {Date} assessmentDate - 評估日期
 * @property {number} assessmentId - 評估id
 * @property {number} hospitalId - 醫療機構id
 * @property {string | undefined} fileUrl - 檢查結果圖片網址
 */
export interface TAddRequest {
    userId: number;
    formId: number;
    assessmentDate: string;
    comprehensiveAssessmentId: number | null;
    hospitalId: number;
    fileUrl: string | null;
    form: dementiaCareForm | mentalHealthForm | null;
}

/**
 * 綜合評估服務 - 新增評估單
 * @param {TRequest} request - 請求物件
 * @prop {number} request.userId - 會員id
 * @prop {number} request.formId - 評估單id
 * @prop {Date} request.assessmentDate - 評估日期
 * @prop {number} request.assessmentId - 評估id
 * @prop {number} request.hospitalId - 醫療機構id
 * @prop {string | undefined} request.fileUrl - 檢查結果圖片網址
 * @returns {Promise<AxiosResponse<{ id: number }, TAddRequest>>} - 回應物件
 */
async function apiAddAssessmentForm(request: TAddRequest) {
    const response: AxiosResponse<{ id: number }, TAddRequest> = await axios.request({
        url: '/api/assessment-form',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: request,
    });
    return response;
}

export interface TEditRequest {
    fileUrl: string | null;
    form: dementiaCareForm | mentalHealthForm | null;
    type: AssessmentType;
}

/**
 * 綜合評估服務 - 編輯評估單
 * @param {number} id - 評估單id
 * @param {{ fileUrl: string }} request - 請求物件
 * @prop {string} request.fileUrl - 檢查結果圖片網址
 * @returns {Promise<AxiosResponse<{ id: number }, TEditRequest>>} - 回應物件
 */
async function apiEditAssessmentForm(id: number, request: TEditRequest) {
    const response: AxiosResponse<{ id: number }, TEditRequest> = await axios.request({
        url: '/api/assessment-form/' + id.toString(),
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: request,
    });
    return response;
}

/**
 * 刪除評估單
 * @param {number} id - 評估單id
 * @returns {Promise<AxiosResponse<{ id: number }, TRequest>>} - 回應物件
 */
async function apiDeleteAssessmentForm(id: number) {
    const response: AxiosResponse<{ id: number }, TRequest> = await axios.request({
        url: '/api/assessment-form/' + id.toString(),
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
    });
    return response;
}

/** * @description 文件下載 - 評估單物件
 * @property {string} assessmentName - 評估單名稱
 * @property {AssessmentType} type - 評估單類型: 固定傳'Form'
 * @property {string} path - 評估單檔案路徑
 */
interface TFormItem {
    assessmentName: string;
    type: AssessmentType;
    path: string;
}

/** * 文件下載 - 新增評估單
 * @param {TFormItem} request - 請求物件
 * @prop {string} request.assessmentName - 評估單名稱
 * @prop {AssessmentType} request.type - 評估單類型
 * @prop {string} request.path - 評估單檔案路徑
 * @returns {Promise<AxiosResponse<{ id: number }, TFormItem>>} - 回應物件
 */
async function apiAddAssessmentFormUpload(request: TFormItem) {
    const response: AxiosResponse<{ id: number }, TFormItem> = await axios.request({
        url: '/api/assessment-form/download',
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: request,
    });
    return response;
}
export { apiAddAssessmentForm, apiAddAssessmentFormUpload, apiDeleteAssessmentForm, apiEditAssessmentForm, apiGetAssessmentForm };

